import { get } from 'lodash';

interface MESSAGES {
  [key: string]: string;
}

function getFirstMessage(data: string[] | MESSAGES[]): string {
  if (!data) return '';
  let firstMessage: string = '';

  const message = Object.keys(data);

  if (message) {
    firstMessage =
      get(message, 'details') ||
      get(message, 'detail') ||
      get(message, 'message') ||
      get(message, '0') ||
      '';
  }

  return firstMessage;
}

export default getFirstMessage;
